import { HeaderWithContext as Header } from './Header';

export default Header;